import { AttributionRole, AttributionRoleLabels } from '../@types/CoproUserAttribution';

const REFERENT_PUBLIQUE_VALUE = AttributionRole.REFERENT;

const ROLE_ORDER: AttributionRole[] = [
  AttributionRole.REFERENT,
  AttributionRole.ASSISTANT_REFERENT,
  AttributionRole.GESTIONNAIRE,
  AttributionRole.ASSISTANT_GESTIONNAIRE,
  AttributionRole.TRANSACTIONNAIRE,
  AttributionRole.GESTIONNAIRE_LOCATIF,
  AttributionRole.INTERVENANT,
];

const roles = ROLE_ORDER.map((role) => ({
  label: AttributionRoleLabels[role],
  value: role,
}));

const getValueByLabel = (label: string) => {
  const foundRole = roles.find((r) => r.label === label);
  return foundRole ? foundRole.value : null;
};

const getLabelByValue = (value: string) => {
  const foundRole = roles.find((r) => r.value === value);
  return foundRole ? foundRole.label : 'Inconnu';
};

const isReferentPubliqueRole = (value: string) => value === REFERENT_PUBLIQUE_VALUE;

export { roles, REFERENT_PUBLIQUE_VALUE, getValueByLabel, getLabelByValue, isReferentPubliqueRole };
